import { useRef } from "react";

export function useElapsedTime() {
  const startTimeRef = useRef<number>(Date.now());

  // 返回一个函数，调用时才计算
  const getElapsed = () => Date.now() - startTimeRef.current;

  return getElapsed;
}
